import { type DocumentType, graphql } from '@generated/gql';

export const FETCH_DEPOSIT_ELIGIBLE_SUB_ACCOUNTS = graphql(/** GraphQL */ `
  query depositEligibleSubAccountsFetchSubAccounts(
    $input: FetchSubAccountsInput!
    $canReadAccountNumber: Boolean!
  ) {
    fetchSubAccounts(input: $input) {
      subAccounts {
        id
        account {
          id
          type
          state
          baseCurrency
          availableCurrencies
          custodianAccountNumber @include(if: $canReadAccountNumber)
          statistics {
            marketValueCents
          }
        }
        financialProduct {
          translatedName {
            ...ProductTranslatedString
          }
        }
        statistics {
          currency
          marketValueCents
        }
      }
    }
  }
`);

export type DepositEligibleSubAccount = DocumentType<
  typeof FETCH_DEPOSIT_ELIGIBLE_SUB_ACCOUNTS
>['fetchSubAccounts']['subAccounts'][number];
